<template>
  <div class="medium-12 columns">
    <div class="templates__list-search">
      <fluent-icon icon="search" class="search-icon" size="16" />
      <input
        ref="search"
        v-model="query"
        type="search"
        :placeholder="$t('WHATSAPP_TEMPLATES.PICKER.SEARCH_PLACEHOLDER')"
        class="templates__search-input"
      />
    </div>
    <div class="template__list-container">
      <div v-for="(template, i) in filteredTemplateMessages" :key="template.id">
        <div class="button-row">
          <button
            class="template__list-item"
            :class="statusClass(template)"
            @click="$emit('onSelect', template)"
          >
            <div>
              <div class="flex-between">
                <p class="label-title">{{ template.name }}</p>
                <span class="label-lang label">
                  {{ $t('WHATSAPP_TEMPLATES.PICKER.LABELS.LANGUAGE') }} :
                  {{ template.language }}
                </span>
                <span class="label-lang label">
                  {{ $t('WHATSAPP_TEMPLATES.CREATOR.STATUS.LABEL') }} : {{ ptStatus(template) }}
                </span>
              </div>
              <div>
                <p class="strong">
                  {{ $t('WHATSAPP_TEMPLATES.PICKER.LABELS.TEMPLATE_BODY') }}
                </p>
                <p class="label-body">{{ getTemplateBody(template) }}</p>
              </div>
              <div class="label-category">
                <p class="strong">
                  {{ $t('WHATSAPP_TEMPLATES.PICKER.LABELS.CATEGORY') }}
                </p>
                <p>{{ template.category }}</p>
              </div>
            </div>
          </button>
          <div
            v-if="
              templateIsImage(template) ||
                templateIsDocument(template) ||
                templateIsVideo(template)
            "
            class="media-preview"
          >
            <button @click="onInnerButtonClick(template)">
              <img
                v-if="templateIsImage(template)"
                class="image-preview"
                :src="`${getTemplateImage(template)}`"
              />
              <vue-pdf-embed
                v-if="templateIsDocument(template)"
                :source="`${getTemplateDocument(template)}`"
                :width="85"
                :scale="1"
                :page="1"
              />
              <video
                v-if="templateIsVideo(template)"
                class="image-preview"
                :src="getTemplateVideo(template)"
                width="100"
                @click="expandVideo($event)"
              />
            </button>
            <media-modal
              :show="mediaPreview"
              :template="selectedTemplate"
              @cancel="mediaPreview = false"
            />
            <file-upload
              class="change-media"
              :input-id="template.id"
              :accept="
                templateIsImage(template)
                  ? 'image/png,image/gif,image/jpeg'
                  : templateIsVideo(template)
                  ? 'video/mp4,video/avi,video/mpeg'
                  : 'application/pdf'
              "
              @input-file="onDirectFileUpload($event, template)"
            >
              <button class="change-button">
                {{ $t('WHATSAPP_TEMPLATES.PICKER.CHANGE_BUTTON') }}
              </button>
            </file-upload>
          </div>
        </div>
        <hr v-if="i != filteredTemplateMessages.length - 1" :key="`hr-${i}`" />
      </div>
      <div v-if="!filteredTemplateMessages.length">
        <p>
          {{ $t('WHATSAPP_TEMPLATES.PICKER.NO_TEMPLATES_FOUND') }}
          <strong>{{ query }}</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { DirectUpload } from 'activestorage';
import axios from 'axios';
import {
  buildContactDirectUploadUrl,
  buildBlobUrl,
  getDirectUploadBaseUrl,
} from 'dashboard/helper/directUploadHelper';
import alertMixin from 'shared/mixins/alertMixin';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import FileUpload from 'vue-upload-component';
import { mapGetters } from 'vuex';
import whatsappTemplateApi from '../../../../api/whatsappTemplate';
import MediaModal from './MediaModal.vue';

export default {
  components: {
    VuePdfEmbed,
    MediaModal,
    FileUpload,
  },
  mixins: [alertMixin],
  props: {
    contactId: {
      type: Number,
      default: undefined,
    },
    inboxId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      query: '',
      mediaPreview: false,
      selectedTemplate: null,
      attachedFiles: [],
    };
  },
  watch: {},
  mounted() {
    this.$store.dispatch('inboxes/revalidate', { newKey: null });
    document.addEventListener('fullscreenchange', this.onFullscreenChange);
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
      currentChat: 'getSelectedChat',
    }),
    whatsAppTemplateMessages() {
      const templates = this.$store.getters['inboxes/getWhatsAppTemplates'](
        this.inboxId
      );
      if (Array.isArray(templates)) {
        return templates.filter(
          template => template.status.toLowerCase() === 'approved'
        );
      }
      return [];
    },
    filteredTemplateMessages() {
      const lowerCaseQuery = this.query.toLowerCase();
      return this.whatsAppTemplateMessages.filter(template =>
        template.name.toLowerCase().includes(lowerCaseQuery)
      );
    },
  },
  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.onFullscreenChange);
  },
  methods: {
    statusClass(template) {
      const s = (template?.status || '').toLowerCase();
      if (s === 'approved') return 'status-approved';
      if (s === 'pending') return 'status-pending';
      return 'status-other';
    },
    ptStatus(template) {
      const s = (template?.status || '').toLowerCase();
      if (s === 'approved') return 'Aprovado';
      if (s === 'pending') return 'Pendente';
      if (s === 'rejected') return 'Rejeitado';
      return 'Desconhecido';
    },
    expandVideo(event) {
      const video = event.target;
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      }

      this.isVideoFullscreen = true;
    },
    onFullscreenChange() {
      if (!document.fullscreenElement && this.isVideoFullscreen) {
        this.isVideoFullscreen = false;
        this.closeVideo();
      }
    },

    closeVideo() {
      this.mediaPreview = false;
      this.selectedTemplate = null;
    },
    openFileUpload(event) {
      event.stopPropagation();
    },
    updateTemplateList() {
      const templates = this.$store.getters['inboxes/getWhatsAppTemplates'](
        this.inboxId
      );
      if (Array.isArray(templates)) {
        this.filteredTemplateMessages = templates.filter(
          template => template.status.toLowerCase() === 'approved'
        );
      }
    },
    onInnerButtonClick(template) {
      event.stopPropagation();
      this.selectedTemplate = template;
      this.mediaPreview = true;
    },
    async onDirectFileUpload(file, template) {
      if (!file) {
        return;
      }

      // Validar tipo de arquivo antes do upload
      const fileType = file.file?.type || file.type;
      const fileName = file.file?.name || file.name || '';
      const fileExtension = fileName.split('.').pop()?.toLowerCase();

      let isValidType = false;

      if (this.templateIsImage(template)) {
        const validImageTypes = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
        const validImageExtensions = ['png', 'gif', 'jpg', 'jpeg'];
        isValidType = validImageTypes.includes(fileType) || validImageExtensions.includes(fileExtension);
      } else if (this.templateIsVideo(template)) {
        const validVideoTypes = ['video/mp4', 'video/avi', 'video/mpeg', 'video/quicktime'];
        const validVideoExtensions = ['mp4', 'avi', 'mpeg', 'mov'];
        isValidType = validVideoTypes.includes(fileType) || validVideoExtensions.includes(fileExtension);
      } else if (this.templateIsDocument(template)) {
        isValidType = fileType === 'application/pdf' || fileExtension === 'pdf';
      }

      if (!isValidType) {
        const typeLabel = this.templateIsImage(template)
          ? this.$t('WHATSAPP_TEMPLATES.CREATOR.HEADER.TYPES.image') + ' (PNG, GIF, JPEG)'
          : this.templateIsVideo(template)
          ? this.$t('WHATSAPP_TEMPLATES.CREATOR.HEADER.TYPES.video') + ' (MP4, AVI, MPEG)'
          : this.$t('WHATSAPP_TEMPLATES.CREATOR.HEADER.TYPES.document') + ' (PDF)';
        this.showAlert(this.$t('WHATSAPP_TEMPLATES.PICKER.INVALID_FILE_TYPE', { type: typeLabel }));
        return;
      }

      const uploadUrl = buildContactDirectUploadUrl(
        this.accountId,
        this.contactId
      );
      const upload = new DirectUpload(file.file, uploadUrl, {
        directUploadWillCreateBlobWithXHR: xhr => {
          xhr.setRequestHeader(
            'api_access_token',
            this.currentUser.access_token
          );
        },
      });

      upload.create(async (error, blob) => {
        if (error) {
          this.showAlert(error);
        } else {
          const fileUrl = buildBlobUrl(blob.signed_id, blob.filename);
          template.media_url = fileUrl;
          if (
            this.templateIsImage(template) ||
            this.templateIsDocument(template) ||
            this.templateIsVideo(template)
          ) {
            const payload = new FormData();
            payload.append('account_id', this.accountId);
            payload.append('media_url', fileUrl);
            payload.append(
              'media_id',
              template.media_id ? template.media_id : ''
            );
            payload.append('template_id', template.id);
            payload.append('inbox_id', this.inboxId);
            payload.append('file', file.file);
            const newTemplate = await whatsappTemplateApi.setTemplateMedia(
              payload
            );
            template.media_id = newTemplate?.data?.media_id;
            this.$store.dispatch('inboxes/revalidate', { newKey: fileUrl });
          }
        }
      });
    },
    templateIsImage(template) {
      return template?.components[0]?.format === 'IMAGE';
    },
    templateIsDocument(template) {
      return template?.components[0]?.format === 'DOCUMENT';
    },
    getTemplateBody(template) {
      return template.components.find(component => component.type === 'BODY')
        .text;
    },
    getTemplateImage(template) {
      if (template?.media_url) {
        return `${template.media_url}`;
      }
      this.uploadMetaImageTemplate(template);
      return template?.components[0]?.example?.header_handle[0];
    },
    getTemplateDocument(template) {
      if (!template.media_url) {
        this.uploadMetaDocumentTemplate(template);
      }
      return template?.media_url;
    },
    getTemplateVideo(template) {
      if (!template.media_url) {
        this.uploadMetaVideoTemplate(template);
      }
      return template?.media_url;
    },
    async uploadMetaDocumentTemplate(template) {
      const baseUrl = getDirectUploadBaseUrl();
      const uploadUrl = buildContactDirectUploadUrl(
        this.accountId,
        this.contactId
      );
      axios
        .get(`${baseUrl}/api/v1/accounts/${this.accountId}/contacts/${this.contactId}/direct_uploads/get_blob`, {
          params: { url: template?.components[0]?.example?.header_handle[0] },
          responseType: 'arraybuffer',
        })
        .then(response => {
          const buffer = response.data;
          const blob = new Blob([buffer], { type: 'application/pdf' });
          const file = new File([blob], 'arquivo.pdf', {
            type: 'application/pdf',
          });
          const upload = new DirectUpload(file, uploadUrl, {
            directUploadWillCreateBlobWithXHR: xhr => {
              xhr.setRequestHeader(
                'api_access_token',
                this.currentUser.access_token
              );
            },
          });

          upload.create(async (error, blob) => {
            if (error) {
              this.showAlert(error);
            } else {
              const fileUrl = buildBlobUrl(blob.signed_id, blob.filename);
              if (
                this.templateIsImage(template) ||
                this.templateIsDocument(template)
              ) {
                const payload = new FormData();
                payload.append('account_id', this.accountId);
                payload.append('media_url', fileUrl);
                payload.append(
                  'media_id',
                  template.media_id ? template.media_id : ''
                );
                payload.append('template_id', template.id);
                payload.append('inbox_id', this.inboxId);
                payload.append('file', file);
                const newTemplate = await whatsappTemplateApi.setTemplateMedia(
                  payload
                );
                template.media_id = newTemplate?.data?.media_id;
              }
            }
          });
        })
        .catch(error => {
          console.error('Erro ao processar o arquivo:', error);
        });
    },
    async uploadMetaImageTemplate(template) {
      const baseUrl = getDirectUploadBaseUrl();
      const uploadUrl = buildContactDirectUploadUrl(
        this.accountId,
        this.contactId
      );
      axios
        .get(`${baseUrl}/api/v1/accounts/${this.accountId}/contacts/${this.contactId}/direct_uploads/get_blob`, {
          params: { url: template?.components[0]?.example?.header_handle[0] },
          responseType: 'arraybuffer',
        })
        .then(response => {
          const buffer = response.data;
          const blob = new Blob([buffer], { type: 'image/png' });
          const file = new File([blob], 'arquivo.png', { type: 'image/png' });

          const upload = new DirectUpload(file, uploadUrl, {
            directUploadWillCreateBlobWithXHR: xhr => {
              xhr.setRequestHeader(
                'api_access_token',
                this.currentUser.access_token
              );
            },
          });

          upload.create(async (error, blob) => {
            if (error) {
              this.showAlert(error);
            } else {
              const fileUrl = buildBlobUrl(blob.signed_id, blob.filename);
              if (this.templateIsImage(template)) {
                const payload = new FormData();
                payload.append('account_id', this.accountId);
                payload.append('media_url', fileUrl);
                payload.append(
                  'media_id',
                  template.media_id ? template.media_id : ''
                );
                payload.append('template_id', template.id);
                payload.append('inbox_id', this.inboxId);
                payload.append('file', file);
                const newTemplate = await whatsappTemplateApi.setTemplateMedia(
                  payload
                );
                template.media_id = newTemplate?.data?.media_id;
              }
            }
          });
        })
        .catch(error => {
          console.error('Erro ao processar o arquivo:', error);
        });
    },

    templateIsVideo(template) {
      return template?.components[0]?.format === 'VIDEO';
    },

    async uploadMetaVideoTemplate(template) {
      const baseUrl = getDirectUploadBaseUrl();
      const uploadUrl = buildContactDirectUploadUrl(
        this.accountId,
        this.contactId
      );
      axios
        .get(`${baseUrl}/api/v1/accounts/${this.accountId}/contacts/${this.contactId}/direct_uploads/get_blob`, {
          params: { url: template?.components[0]?.example?.header_handle[0] },
          responseType: 'arraybuffer',
        })
        .then(response => {
          const buffer = response.data;
          const blob = new Blob([buffer], { type: 'video/mp4' });
          const file = new File([blob], 'arquivo.mp4', { type: 'video/mp4' });

          const upload = new DirectUpload(file, uploadUrl, {
            directUploadWillCreateBlobWithXHR: xhr => {
              xhr.setRequestHeader(
                'api_access_token',
                this.currentUser.access_token
              );
            },
          });

          upload.create(async (error, blob) => {
            if (error) {
              this.showAlert(error);
            } else {
              const fileUrl = buildBlobUrl(blob.signed_id, blob.filename);
              if (this.templateIsVideo(template)) {
                const payload = new FormData();
                payload.append('account_id', this.accountId);
                payload.append('media_url', fileUrl);
                payload.append(
                  'media_id',
                  template.media_id ? template.media_id : ''
                );
                payload.append('template_id', template.id);
                payload.append('inbox_id', this.inboxId);
                payload.append('file', file);
                const newTemplate = await whatsappTemplateApi.setTemplateMedia(
                  payload
                );
                template.media_id = newTemplate?.data?.media_id;
              }
            }
          });
        })
        .catch(error => {
          console.error('error processing file:', error);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.flex-between {
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--space-one);
}

.templates__list-search {
  align-items: center;
  background-color: var(--s-25);
  border-radius: var(--border-radius-medium);
  border: 1px solid var(--s-100);
  display: flex;
  margin-bottom: var(--space-one);
  padding: 0 var(--space-one);

  .search-icon {
    color: var(--s-400);
  }

  .templates__search-input {
    background-color: transparent;
    border: none;
    font-size: var(--font-size-mini);
    height: unset;
    margin: 0;
  }
}

.template__list-container {
  background-color: var(--s-25);
  border-radius: var(--border-radius-medium);
  max-height: 30rem;
  overflow-y: auto;
  padding: var(--space-one);

  .media-preview {
    display: flex;
    flex-direction: column;
    z-index: 3;
  }

  .template__list-item {
    border-radius: var(--border-radius-medium);
    cursor: pointer;
    display: block;
    padding: var(--space-one);
    text-align: left;
    width: 100%;
    z-index: 2;

    &:hover {
      background-color: var(--w-50);
    }

    .label-title {
      font-size: var(--font-size-small);
    }

    .label-category {
      margin-top: var(--space-two);

      span {
        font-size: var(--font-size-small);
        font-weight: var(--font-weight-bold);
      }
    }

    .label-body {
      font-family: monospace;
    }

      &.status-pending {
        background-color: #fff8e6; /* leve amarelo */
      }
      &.status-approved {
        background-color: #e9f9ee; /* leve verde */
      }
      &.status-other {
        background-color: #ffecee; /* leve vermelho */
      }
  }
}

// No dark os fundos claros por status (#fff8e6/#e9f9ee/#ffecee) deixam o
// texto branco ilegível — tinta escura translúcida da cor. O hover usava
// --w-50 (azul claro não temado), trocado pelo woot-tint escuro. US-4328
:root[data-theme='dark'] .template__list-item.status-pending {
  background-color: rgba(230, 192, 12, 0.16);
}
:root[data-theme='dark'] .template__list-item.status-approved {
  background-color: rgba(0, 196, 29, 0.16);
}
:root[data-theme='dark'] .template__list-item.status-other {
  background-color: rgba(255, 56, 45, 0.16);
}
:root[data-theme='dark'] .template__list-item:hover {
  background-color: var(--color-woot-tint);
}

.button-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.image-preview {
  border-radius: 5px 5px 0 0;
  width: 85px;
}

.change-media {
  border-radius: 0 0 5px 5px;
  background-color: #47a6ff;
  width: 85px;
}

.strong {
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-bold);
}

hr {
  border-bottom: 1px solid var(--s-100);
  margin: var(--space-one) auto;
  max-width: 95%;
}
</style>
